import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoKy: CultureInfo = {
  name: 'ky',
  displayName: 'Kyrgyz',
  iso3LanguageCode: 'kir',
  iso2LanguageCode: 'ky',
  ietfLanguageTag: 'ky',
  parent: null
};
